import * as React from 'preact/compat'
import type { GameInfo } from '../SeriesEditor/types'
import styles from '../../../css/game-series-scheme.pcss.json'
import RootLine from './RootLine'
import RelationLine from './RelationLine'
import { SeriesSchemeState } from './state'

interface PropTypes {
  roots: Array<GameInfo>
  recenter: () => void
}

export default class LinesRenderer extends React.Component<PropTypes, any> {
  static contextType = SeriesSchemeState
  declare context: React.ContextType<typeof SeriesSchemeState>
  flag = 0;
  container = null
  width = 0
  height = 0

  setLinesWrapper = (node: SVGSVGElement) => {
    this.context.setLinesWrapper(node)
  }

  componentDidMount() {
    this.props.recenter()
  }

  render() {
    const { roots } = this.props
    const { gamesRelations, container } = this.context
    if (this.flag === 1) {
      this.flag = 1.00001;
    } else {
      this.flag = 1;
    }
    if (container.value && container.value !== this.container) {
      this.container = container.value
      const containerBBox = this.container.getBoundingClientRect()
      this.width = containerBBox.width
      this.height = containerBBox.height
    }

    return <svg
      className={styles['linesWrapper']}
      xmlns='http://www.w3.org/2000/svg'
      viewBox={`0 0 ${this.width * this.flag} ${this.height}`}
      style={{
        width: `${this.width * this.flag}px`,
        height: `${this.height}px`
      }} ref={this.setLinesWrapper}
    >
      <defs>
        <marker
          id="scheme-line-marker"
          viewBox='0 0 10 10'
          refX='5'
          refY='5'
          markerWidth='10'
          markerHeight='10'
          markerUnits='userSpaceOnUse'
        >
          <circle r='5' fill='currentColor' cx='5' cy='5' />
        </marker>
        <marker
          id="scheme-line-marker-highlight"
          viewBox='0 0 10 10'
          refX='5'
          refY='5'
          markerWidth='10'
          markerHeight='10'
          markerUnits='userSpaceOnUse'
        >
          <circle r='5' fill='var(--green)' cx='5' cy='5' />
        </marker>
      </defs>
      {roots.map(root => <RootLine root={root} key={`relation_series_node_${root.id}`}/>)}
      {gamesRelations.value.sort((relation1, relation2) => {
        const hasRelation1 = this.context.highlightedRelations.value.includes(relation1)
        const hasRelation2 = this.context.highlightedRelations.value.includes(relation2)
        if (hasRelation1 === hasRelation2) {
          return 0
        }
        if (hasRelation1 && !hasRelation2) {
          return 1
        }
        if (hasRelation2 && !hasRelation1) {
          return -1
        }
      })
        .map(relation => <RelationLine
          relation={relation}
          key={`relation_node_${relation.first_game_id}_node_${relation.second_game_id}`}
        />)}
    </svg>
  }
}
